import { URL_BY_BRAND } from "@/constant/constantsThrougoutProject";

const REDIRECT_PRIORITY_ORDER = [
  "visibility",
  "equity",
  "conversion",
  "emotional",
  "advertising",
  "reputation",
  "exclusivequestions",
];

export const getFeatureRedirect = (
  status: Record<string, Record<string, boolean>>
): string => {
  const orderedKeys = [
    ...REDIRECT_PRIORITY_ORDER.filter((key) => key in status),
    ...Object.keys(status).filter((key) => !REDIRECT_PRIORITY_ORDER.includes(key)),
  ];

  for (const key of orderedKeys) {
    if (
      Object.prototype.hasOwnProperty.call(status, key) &&
      typeof status[key] === "object" &&
      status[key] !== null
    ) {
      const subObject = status[key];
      const subKeys = Object.keys(subObject);
      const allTrue = subKeys.every((subKey) => subObject[subKey] === true);

      if (allTrue && subKeys.length > 0) {
        return `/${key}/${URL_BY_BRAND}`;
      }
    }
  }

  return "";
};
